import React from 'react';
import { SwitchBtn } from '@components';
// import './HeadcountSalesSwitch.scss';

function HeadcountSalesSwitch({ handleSwitch, checked }) {
  return (
    <div className="headcount-sales-switch">
      Employee Headcount
      <SwitchBtn
        onClick={handleSwitch}
        size="default"
        className="switch-btn"
        checked={checked}
      />
      Sales ($ ‘000S)
    </div>
  );
}

export default HeadcountSalesSwitch;
